export const TIMEOUT = 400;
export const SITEKEY = "6Leqhv8UAAAAACJT4NbdQnSYs4FeVulG3GRe_Msn";
